import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';
import { Skeleton } from './skeleton';

interface KPICardProps {
    title: string;
    value: string | number;
    subtitle?: string;
    icon: LucideIcon;
    trend?: {
        value: number;
        isPositive: boolean;
    };
    loading?: boolean;
    className?: string;
}

export function KPICard({
    title,
    value,
    subtitle,
    icon: Icon,
    trend,
    loading,
    className
}: KPICardProps) {
    if (loading) {
        return (
            <div className={cn("kpi-card", className)}>
                <div className="flex items-start justify-between">
                    <Skeleton className="h-4 w-24" />
                    <Skeleton className="h-10 w-10 rounded-lg" />
                </div>
                <Skeleton className="h-8 w-16 mt-4" />
                <Skeleton className="h-4 w-32 mt-2" />
            </div>
        );
    }

    return (
        <div className={cn("kpi-card group", className)}>
            <div className="flex items-start justify-between">
                <p className="text-sm font-medium text-muted-foreground">{title}</p>
                <div className="kpi-icon group-hover:scale-110 transition-transform duration-200">
                    <Icon className="h-5 w-5" />
                </div>
            </div>
            <div className="mt-3">
                <p className="kpi-value">{value}</p>
                {subtitle && (
                    <p className="kpi-label">{subtitle}</p>
                )}
                {trend && (
                    <div className={cn(
                        "flex items-center gap-1 mt-2 text-xs font-medium",
                        trend.isPositive ? "text-success" : "text-destructive"
                    )}>
                        <span>{trend.isPositive ? '↑' : '↓'}</span>
                        <span>{Math.abs(trend.value)}%</span>
                        <span className="text-muted-foreground">vs last week</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default KPICard;

